import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="primary">
          <div className="first">
            <div className="logo">
              <h2>
              <i class="fa-solid fa-graduation-cap"></i> India Alumni
              </h2>
            </div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Perferendis, consequuntur!
            </p>
            <h5>Follow Us</h5>
            <div className="social_media">
              <i class="fa-brands fa-facebook"></i>
              <i class="fa-brands fa-github"></i>
              <i class="fa-brands fa-x-twitter"></i>
              <i class="fa-brands fa-linkedin"></i>
              <i class="fa-brands fa-instagram"></i>
            </div>
          </div>
          <div className="second">
            <div>
              <h5>Company</h5>
              <Link to={"/privacy-policy"}  className="pr-policy"><p >Privacy Policy </p></Link>
              <p>About us</p>
              <p>FAQ</p>
              <p>Contact</p>
            </div>
            <div>
              <h5>Pages</h5>
              <p>Our Team</p>
              <p>Career</p>
              <p>404 Page</p>
            </div>
          </div>
          <div className="third">
            <h3>Subscribe to the latest news</h3>
            <p>
              Stay in the loop and never miss out on the latest updates
              insights, and trends by subscribing to our newsletter!
            </p>
            <div>
                <input type="text" placeholder="Your email address" />
                <button className="btn_solid">Subscribe</button>
            </div>
          </div>
        </div>
        <div className="bottom">
          <p>
            Copyright © 2024 <a href="http://www.infowareindia.com" target="_blank">www.infowareindia.com</a> | All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
